import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';

export const Collapse: StyleRule = () => ({
    width: pxToRem(20),
    height: pxToRem(20),
});

export const HalfChecked: StyleRule = ({ theme }) => ({
    backgroundColor: theme.siteVariables.colors.charcoal['250'],
    position: 'relative',
    width: pxToRem(16),
    height: pxToRem(16),
    borderRadius: '12.5%',
    [`& .ui-icon`]: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        [`& svg`]: {
            fill: theme.siteVariables.colors.primitive.white,
        },
    },
});

export const AwardsFilterTree: StyleRule = ({ theme }) => ({
    [`& ol`]: {
        padding: 0,
        margin: 0,
    },
    [`& .rct-node`]: {
        listStyle: 'none',
        [`& input[type="checkbox"]`]: {
            display: 'none',
        },
        [`& .rct-collapse`]: {
            order: 1,
            marginLeft: 'auto',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
            padding: pxArrayToRem([0, 10]),
        },
        [`& .rct-text`]: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: pxToRem(8),
            marginBottom: pxToRem(8),
            [`& .rct-title`]: {
                ...theme.siteVariables.textStyles.Text.Roman55,
                fontSize: theme.siteVariables.fontSizes['caption03'],
            },
        },
        [`& .rct-checkbox`]: {
            cursor: 'pointer',
        },
        [`& ol`]: {
            marginLeft: pxToRem(24),
        },
    },
    [`&> .rct-disabled`]: {
        opacity: 0.4,
        [`& .rct-node-clickable`]: {
            cursor: 'not-allowed',
        },
        [`& .rct-checkbox`]: {
            cursor: 'not-allowed',
        },
    },
});
